// extracted by mini-css-extract-plugin
export default {"wrap":"graph-tab-module_wrap_qSvFZ","leadBtn":"graph-tab-module_leadBtn_CWwHv","disabled":"graph-tab-module_disabled_WKygg"};